import { formatEta, formatExact } from '../economy/live-resources.ts';
import { useLiveResources } from '../economy/live-store.ts';

/**
 * Raktár-mérő (research v2): how full the stockpile is and when it fills up — shown in the research and the
 * construction views next to the header bar. Reads the one live store, so the capacity includes the storage
 * technologies and megaprojects the moment the server reports them.
 */
export function StorageGauge({ testId = 'storage-gauge' }: { testId?: string }) {
  const live = useLiveResources();
  if (!live || live.metalCapacity === null || live.energyCapacity === null) return null;
  const rows = [
    { key: 'metal', label: 'Fém', icon: '⚙️', amount: live.metal, cap: live.metalCapacity, full: live.metalFull, inH: live.metalFullInH, rate: live.metalPerHour, color: '#9fb3c1' },
    { key: 'energy', label: 'Energia', icon: '⚡', amount: live.energy, cap: live.energyCapacity, full: live.energyFull, inH: live.energyFullInH, rate: live.energyPerHour, color: '#ffd54f' },
  ];
  return (
    <section className="sci-fi-panel rounded-xl p-3" aria-label="Raktár" data-testid={testId}>
      <h2 className="text-sm font-semibold text-slate-300 mb-2">Raktár</h2>
      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {rows.map(r => {
          const pct = Math.min(100, Math.round((r.amount / r.cap) * 100));
          const status = r.full ? 'Tele a raktár, a termelés áll'
            : r.inH !== null ? `Megtelik ${formatEta(r.inH)} múlva`
            : r.rate < 0 ? 'Fogyóban van' : 'Nem telik';
          return (
            <li key={r.key} data-testid={`${testId}-${r.key}`} data-capacity={r.cap} data-percent={pct}>
              <div className="flex justify-between text-xs">
                <span className="text-slate-300">{r.icon} {r.label}</span>
                <span className="font-mono text-slate-200">{formatExact(r.amount)} / {formatExact(r.cap)} ({pct}%)</span>
              </div>
              <div className="mt-1 h-2 rounded bg-slate-800 overflow-hidden" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={pct} aria-label={`${r.label} raktár telítettsége`}>
                <div className="h-full transition-all" style={{ width: `${pct}%`, background: pct >= 90 ? '#f87171' : r.color }} />
              </div>
              <p className="mt-1 text-[11px] text-slate-400" data-testid={`${testId}-${r.key}-eta`}>{status}</p>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
